'use client'

import type { ReactNode } from 'react'
import { queryClient } from '@common/query'
import { QueryClientProvider } from '@tanstack/react-query'

export function Providers({ children }: { children: ReactNode }) {
  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
